import { DC } from "../../constants";

export const infinityChallenges = [
  {
    id: 1,
    description: `все Ограничения Нормальных Челленджей активны одновременно, за исключением Челленджа
      Скорости Тика (Ч9) и Челленджа Большого Хруста (Ч12).`,
    goal: DC.E650,
    isQuickResettable: true,
    reward: {
      description: () => `${formatX(1.3, 1, 1)} ко всем Измерениям Бесконечности за каждый пройденный Бесконечный
      Челлендж`,
      effect: () => Math.pow(1.3, InfinityChallenges.completed.length),
      formatEffect: value => formatX(value, 1, 1)
    },
    unlockAM: DC.E2000,
  },
  {
    id: 2,
    description: () => `Жертвование Измерений происходит автоматически каждые ${formatInt(400)} миллисекунд, как только
      вы получите 8ое Измерение Антиматерии.`,
    goal: DC.E10500,
    isQuickResettable: false,
    reward: {
      description: () => `АвтоПокупщик Жертвования Измерений. Жертвование Измерений становится сильнее.
        ${Sacrifice.getSacrificeDescription({ "InfinityChallenge2isCompleted": false })} ➜
        ${Sacrifice.getSacrificeDescription({ "InfinityChallenge2isCompleted": true })}`,
    },
    unlockAM: DC.E11000,
  },
  {
    id: 3,
    description: () =>
      `Улучшения Скорости Тика всегда ${formatX(1)}. За каждое купленное улучшение Скорости Тика, вы, взамен, получаете
      статичный множитель ко всем Измерениям Антиматерии, увеличивающийся на основе Галактик Антиматерии.`,
    goal: DC.E5000,
    isQuickResettable: false,
    effect: () => Decimal.pow(1.05 + (player.galaxies * 0.005), player.totalTickBought),
    formatEffect: value => formatX(value, 2, 2),
    reward: {
      description: `Множитель Измерений Антиматерии, основанный на Галактиках Антиматерии и покупках Скорости Тика`,
      effect: () => (Laitela.continuumActive
        ? Decimal.pow(1.05 + (player.galaxies * 0.005), Tickspeed.continuumValue)
        : Decimal.pow(1.05 + (player.galaxies * 0.005), player.totalTickBought)),
      formatEffect: value => formatX(value, 2, 2),
    },
    unlockAM: DC.E12000,
  },
  {
    id: 4,
    description: () =>
      `производство только последнего купленного Измерения Антиматерии нормальное. Все остальные Измерения Антиматерии
      производят меньше на (${formatPow(0.25, 2, 2)}).`,
    goal: DC.E13000,
    isQuickResettable: true,
    effect: 0.25,
    reward: {
      description: () => `Все множители Измерений Антиматерии становятся больше на ${formatPow(1.05, 2, 2)}`,
      effect: 1.05
    },
    unlockAM: DC.E14000,
  },
  {
    id: 5,
    description:
      `покупка Измерений Антиматерии 1-4 увеличивает цены всех более дешевых ИА.
      Покупка Измерений Антиматерии увеличивает цену всех более дорогих ИА.`,
    goal: DC.E16500,
    isQuickResettable: true,
    reward: {
      description: () =>
        `Все Галактики на ${formatPercents(0.1)} сильнее. Уменьшение требования к ним и Бустам Измерений на
        ${formatInt(1)}`,
      effect: 1.1
    },
    unlockAM: DC.E18000,
  },
  {
    id: 6,
    description: () =>
      `экспоненциально увеличивающаяся материя делит множители на всех ваших Измерениях Антиматерии, как только вы
      получите как минимум ${formatInt(1)} 2ое Измерение Антиматерии.`,
    goal: DC.D2E22222,
    isQuickResettable: true,
    effect: () => Currency.matter.value.clampMin(1),
    formatEffect: value => `/${format(value, 1, 2)}`,
    reward: {
      description: "Множитель Измерений Антиматерии, основанный на скорости тика",
      effect: () => Tickspeed.perSecond.pow(0.0005),
      formatEffect: value => formatX(value, 2, 2)
    },
    unlockAM: DC.E22500,
  },
  {
    id: 7,
    description: () => {
      // Copied from DimBoost.power; this is the base amount before any multipliers. Post-eternity this isn't
      // necessarily 2.5x by the time the player sees this challenge; it's probably most accurate to say what it
      // currently is, and this phrasing avoids 10x ➜ 10x with the old description.
      const mult = Effects.max(
        2,
        InfinityUpgrade.dimboostMult,
        InfinityChallenge(7).reward,
        TimeStudy(81)
      );
      return `вы не можете покупать Галактики Антиматерии. Базовый множитель Буста Измерений увеличен до максимума в
        ${formatX(10)}. (Текущий базовый множитель: ${formatX(mult, 2, 1)})`;
    },
    goal: DC.E10000,
    isQuickResettable: false,
    effect: 10,
    reward: {
      description: () => `Множитель Буста Измерений увеличен до минимума в ${formatX(4)}`,
      effect: 4
    },
    unlockAM: DC.E23000,
  },
  {
    id: 8,
    description: () =>
      `Производство ИА стремительно и непрерывно падает со временем. Покупка Измерения Антиматерии или улучшния Скорости
        Тика сбрасывает производство назад на ${formatPercents(1)} до того, как оно вновь начинает падать.`,
    goal: DC.E27000,
    isQuickResettable: true,
    effect: () => DC.D0_8446303389034288.pow(
      Math.max(0, player.records.thisInfinity.time - player.records.thisInfinity.lastBuyTime)),
    reward: {
      description:
        "Вы получаете множитель к ИА 2-7, основанный на множителях 1ого и 8ого ИА.",
      effect: () => AntimatterDimension(1).multiplier.times(AntimatterDimension(8).multiplier).pow(0.02),
      formatEffect: value => formatX(value, 2, 2)
    },
    unlockAM: DC.E28000,
  },
];
